import {ProgressBar} from '@primer/react'
import {SkeletonText} from '@primer/react/experimental'
import type {SidebarLanguagesProps} from '../types'
import {SidebarSection} from './SidebarSection'
import {SidebarLink} from './SidebarLink'
import styles from './SidebarLanguages.module.css'

/** Renders the language breakdown bar and list for the repository sidebar. */
export function SidebarLanguages({languages, isFork, ownerLogin, repoName}: SidebarLanguagesProps) {
  if (languages.length === 0) return null

  return (
    <SidebarSection title="Languages">
      <div className="mb-2">
        <ProgressBar aria-label="Repository language breakdown">
          {languages.map(lang => (
            <ProgressBar.Item
              aria-label={`${lang.name}: ${lang.percentage}%`}
              key={`bar-${lang.name}`}
              progress={lang.percentage}
              style={{backgroundColor: lang.color}}
            />
          ))}
        </ProgressBar>
      </div>
      <ul className={styles.languageList}>
        {languages.map(lang => (
          <li key={`lang-${lang.name}`} className={styles.languageListItem}>
            {isFork ? (
              <span className={styles.languageItem}>
                <span className={styles.languageDot} style={{backgroundColor: lang.color}} />
                <span className={styles.languageName}>{lang.name}</span>
                <span>{lang.percentage}%</span>
              </span>
            ) : (
              <SidebarLink
                to={`/${ownerLogin}/${repoName}/search?l=${encodeURIComponent(lang.name)}`}
                className={styles.languageLink}
                analyticsLabel="section:languages"
              >
                <span className={styles.languageDot} style={{backgroundColor: lang.color}} />
                <span className={styles.languageName}>{lang.name}</span>
                <span>{lang.percentage}%</span>
              </SidebarLink>
            )}
          </li>
        ))}
      </ul>
    </SidebarSection>
  )
}

export function SidebarLanguagesSkeleton() {
  return (
    <SidebarSection title="Languages">
      <SkeletonText />
    </SidebarSection>
  )
}
